/*
 * Sticky add-to-cart bar behavior (see snippets/sticky-add-to-cart.liquid):
 *  - slides up only after the MAIN buy button has scrolled out of view
 *    (never covers the real button);
 *  - mirrors the currently selected variant's title/price by watching the
 *    main form's hidden id input (350ms poll — cheap, and immune to how
 *    Dawn re-renders the form on variant change);
 *  - its button clicks the real submit button, so Dawn's product-form does
 *    the add (loading state, cart drawer open, errors) and nothing desyncs.
 */
(function () {
  function init() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar || bar.dataset.init === '1') return;
    bar.dataset.init = '1';

    var mainBtn = document.getElementById(bar.dataset.mainButtonId);
    if (!mainBtn) return;

    var form = mainBtn.closest('form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;

    var priceEl = bar.querySelector('[data-sticky-price]');
    var variantEl = bar.querySelector('[data-sticky-variant]');
    var btn = bar.querySelector('[data-sticky-submit]');
    var btnText = bar.querySelector('[data-sticky-submit-text]');

    var variants = [];
    try {
      variants = JSON.parse(bar.querySelector('[data-sticky-variants]').textContent);
    } catch (e) {
      /* leave server-rendered values in place */
    }

    // ---- show/hide on scroll ----
    bar.hidden = false; // display handled via transform; keep in a11y tree consistent with visibility below
    var visible = false;
    function setVisible(v) {
      if (v === visible) return;
      visible = v;
      bar.classList.toggle('is-visible', v);
      bar.setAttribute('aria-hidden', v ? 'false' : 'true');
    }
    setVisible(false);

    var io = new IntersectionObserver(
      function (entries) {
        var e = entries[0];
        // Show only once the main button is ABOVE the viewport (scrolled past),
        // not when it's still below the fold on page load.
        setVisible(!e.isIntersecting && e.boundingClientRect.bottom < 0);
      },
      { threshold: 0 }
    );
    io.observe(mainBtn);

    // ---- variant sync (poll the hidden id input) ----
    var lastId = null;
    function sync() {
      // Mirror sold-out/loading state from the real button.
      var mainDisabled = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';

      if (idInput && variants.length) {
        var vid = parseInt(idInput.value, 10);
        if (vid && vid !== lastId) {
          lastId = vid;
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].id === vid) {
              if (priceEl) priceEl.textContent = variants[i].price;
              if (variantEl) variantEl.textContent = variants[i].title;
              if (btnText) btnText.textContent = variants[i].available
                ? (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart'
                : (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
              mainDisabled = mainDisabled || !variants[i].available;
              break;
            }
          }
        }
      }
      if (btn) btn.disabled = mainDisabled;
    }
    sync();
    setInterval(sync, 350);

    // ---- add to cart: delegate to the real button ----
    if (btn) {
      btn.addEventListener('click', function () {
        if (mainBtn.disabled) return;
        mainBtn.click();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
